import { createFileRoute } from '@tanstack/react-router';

import { CouponDetailPage } from '@/pages/coupons/coupon-detail-page';

export const Route = createFileRoute('/coupons/$id')({
  component: CouponDetail,
});

function CouponDetail() {
  const { id } = Route.useParams();
  return <CouponDetailPage id={id} />;
}
